<nav class="header bg-blue-850 dark:bg-gray-800">
  <!-- fitmed icon -->
  <div class="fm-icon-text flex flex-row items-center ml-4">
    <img src="/assets/images/icon/fitmed-icon-coloured.svg" alt="FitMed Icon" class="h-8 w-8">
    <span class="text-white text-sm ml-4 title-font-selector">{{ 'HeaderIconDesc' | localizeText : 'Actively making you better' | titlecase }}</span>
  </div>

  <div class="p-1 flex items-center space-x-2">
    <app-global-search-bar></app-global-search-bar>
    <app-region-selection
      [selectedRegion]="defaultRegion"
      (regionSelected)="handleRegionChange($event)">
    </app-region-selection>
    <app-login-subj-bubble></app-login-subj-bubble>
  </div>
</nav>
